import { Box } from '@mui/material';
import { memo, useContext } from 'react';
import { makeStyles } from '@mui/styles';
import { Theme } from '@mui/material/styles';
import { MenuOutlined } from '@mui/icons-material';

import { Icon } from '../../../../../../../../common/icon';
import { DrawerContext } from '../../../../../navigation/drawer';

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    height: '24px',
    width: '24px',
    color: theme.palette.common.white,
    '& > svg': {
      marginLeft: '-3px'
    },
    '&:hover': {
      cursor: 'pointer',
      color: theme.palette.primary.light
    }
  }
}));

const NavigationButton = () => {
  const { toggleDrawerState } = useContext(DrawerContext);
  const classes = useStyles();

  return (
    <Box
      className={classes.container}
      onClick={() => {
        toggleDrawerState();
      }}
    >
      <Icon icon={MenuOutlined} />
    </Box>
  );
};

export default memo(NavigationButton);
